const sendClearBulkModalEvent = () => {
  window.dispatchEvent(new Event('clear-bulk-modal'))
}

export {sendClearBulkModalEvent}
